import { defineStore } from "pinia";
import { ref } from "vue";

export const useSideMenuStore = defineStore('menu', () => {
  const isSideMenuOpen = ref(false);

  const toggle = () => {
    isSideMenuOpen.value = !isSideMenuOpen.value
  }
  const close = () => {
    isSideMenuOpen.value = false
  }

  return {
    isSideMenuOpen
    , toggle
    , close
  }
})